/* global pendo */

import { useEffect } from "react";

import { User } from "cortex/ui/src/user/model";

export const scriptId = "pendo-script";

const pendoScript = `(function(apiKey){
  (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
  v=['initialize','identify','updateOptions','pageLoad'];
  for(w=0,x=v.length;w<x;++w)(function(m){
  o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push'](
  [m].concat([].slice.call(arguments,0)));};})(v[w]);
  y=e.createElement(n);y.async=!0;
  y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
  z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);
  })(window,document,'script','pendo');
  })('7cd6754c-a688-4232-4c00-52c765806812');`;

interface PendoProps {
  user?: User | null;
}

type PendoInitializeOptions = {
  account?: {
    id: string | number;
    name?: string;
    [key: string]: unknown;
  };
  visitor: {
    email?: string;
    full_name?: string;
    id: string | number;
    role?: string;
    [key: string]: unknown;
  };
};

type PendoAgent = {
  initialize: (opts: PendoInitializeOptions) => void;
};

declare global {
  interface Window {
    pendo?: PendoAgent;
  }

  // eslint-disable-next-line no-var
  var pendo: PendoAgent | undefined;
}

function ensurePendoScript(): void {
  const exists = document.getElementById(scriptId);
  if (exists) return;

  const scriptTag = document.createElement("script");
  scriptTag.setAttribute("id", scriptId);
  scriptTag.textContent = pendoScript;
  document.head.appendChild(scriptTag);
}

export function Pendo({ user }: PendoProps): null {
  useEffect(() => {
    ensurePendoScript();
  }, []);

  useEffect(() => {
    if (!user) return;

    const { account, email, id: userId, name, role } = user;
    const primaryAccount = account?.[0];

    const agent = window.pendo ?? pendo;
    if (!agent) return;

    agent.initialize({
      account: primaryAccount
        ? {
            id: primaryAccount.id,
            name: primaryAccount.name,
          }
        : undefined,
      visitor: {
        email,
        full_name: name,
        id: userId,
        role,
      },
    });
  }, [user]);

  return null;
}
